import { noop } from 'lodash';
import React from 'react';
import { AnalyticsTimePeriod, IAnalyticsContext } from 'types/analytics';

const AnalyticsContext = React.createContext<IAnalyticsContext>({
	tenants: [],
	setTenants: noop,
	timePeriod: AnalyticsTimePeriod.Week,
	setTimePeriod: noop,
	xDomain: [],
	setXDomain: noop
});

export default AnalyticsContext;
